import { render, staticRenderFns } from "./ConsultoriasTabela.vue?vue&type=template&id=28ab221d"
import script from "./ConsultoriasTabela.vue?vue&type=script&lang=js"
export * from "./ConsultoriasTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports